import React, {useState, useEffect} from 'react';
import {Button, Flex, Heading} from "@aws-amplify/ui-react";
import {I18n} from 'aws-amplify/utils';
import NavBarHeaderQuiz from '../ui-components/NavBarHeaderQuiz';
import TestsPage from './TestsPage';
import TestExecutionsPage from './TestExecutionsPage';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { useAuthenticator, withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import Quiz from './Quiz';
import ArithmeticPractice from './ArithmeticPractice';

import {
    MarketingPricingQuiz
} from '../ui-components';
// import {useAuthSignOutAction} from "../ui-components/utils";
import {
    getOverrideProps,
    useAuthSignOutAction,
    useAuth,
    useNavigateAction,
} from "../ui-components/utils";

import axios from 'axios';
import { useLocation } from 'react-router-dom';
// import ArithmeticPractice from "./ArithmeticPractice";

const LandingPage = () => {
    const signOut = useAuthSignOutAction({global: false});
    const { signIn, user } = useAuthenticator((context) => [context.signIn, context.user]);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    // const { user } = useAuthenticator((context) => [context.user]);
    const [currentView, setCurrentView] = useState('landing');
    const [quizState, setQuizState] = useState(null);
    const [userAttributes, setUserAttributes] = useState({});

    const location = useLocation();
    const [checkoutSession, setCheckoutSession] = useState(null);

    const dict = {
        fr: {
            'Plans': 'Forfaits',
            'Sign In': 'Se connecter',
            'Sign in': 'Se connecter',
            "Confirm Password": "Confirmez le mot de passe",
            "Enter your Email": "Entrez votre courriel",
            "Please confirm your Password": "Veuillez confirmer votre mot de passe",
            "Enter your Family Name": "Entrez votre nom de famille",
            "Enter your Given Name": "Entrez votre prénom",
            "Given Name": "Prénom",
            "Family Name": "Nom de famille",
            "Enter your Password": "Entrez votre mot de passe",
            'Forgot your password?': 'Mot de passe oublié?',
            'Create Account': 'Créer un compte',
            'Email': 'courriel',
            'Password': 'mot de passe',
            'Sign Up': "S'inscrire",
            'Go Practice': 'Aller à la pratique',
            'Results': 'Voir tes Résultats',
            'Arithmetic': 'Arithmétique',
            'Welcome to the Quiz App': 'Bienvenue sur l\'application de Quiz'
        },
        es: {
            'Sign In': 'Registrarse',
            'Sign Up': 'Regístrate'
        }
    };

    I18n.putVocabularies(dict);
    I18n.setLanguage('fr');

    useEffect(() => {
        if (currentView === 'plans') {

            setIsAuthenticated(!!user);
        } else {
            setIsAuthenticated(false);
        }
    }, [currentView, user]);

    useEffect(() => {
        async function fetchUserDetails() {
            console.log("Fetching user details...");
            try {
                const userAttributes = await fetchUserAttributes();
                setUserAttributes(userAttributes);
            } catch (err) {
                console.error("Error fetching user details:", err);
            }
        }
        if (isAuthenticated) {
            fetchUserDetails();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://js.stripe.com/v3/pricing-table.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const sessionId = queryParams.get('sess');
        if (sessionId) {
            console.log("Session ID: " + sessionId);

        }
    }, [location]);

    const fetchCheckoutSession = async (sessionId) => {
        try {
            const response = await axios.get(`/api/stripe/checkout-session?sessionId=${sessionId}`);
            console.log("Checkout Session: " + JSON.stringify(response.data));
            setCheckoutSession(response.data);

        } catch (err) {
            console.error("Error fetching checkout session:", err);
        }
    }

    const renderContent = () => {
        switch (currentView) {
            case 'plans':
                if (isAuthenticated) {
                    // const { user } = useAuthenticator((context) => [context.user]);
                    return (
                        <>
                        {/*<Heading>{userAttributes.email}</Heading>*/}
                        {/*<Heading>{userAttributes.sub}</Heading>*/}
                        {/*    <Heading>{user.username}</Heading>*/}
                            <div dangerouslySetInnerHTML={{
                            __html: `
                                <stripe-pricing-table pricing-table-id="${process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}"
                                    publishable-key="${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}"
                                    customer-email="${userAttributes.email}"
                                    client-reference-id="${userAttributes.sub}"
                                   
                                    >
                                    </stripe-pricing-table>
                            `
                        }}/>
                        </>
                    );
                } else {
                    return <Authenticator>
                        {({ signOut, user }) => (
                            <main>
                                <h1>Hello {user.username}</h1>
                                <button onClick={signOut}>Sign out</button>
                            </main>
                        )}
                    </Authenticator>;
                }
            case 'tests':
                // Todo: filtering with grade hardcoded for now. Requires also to filter by topic, grade, type, language, etc.
                //  when filtering by type, we can also add a  case 'training' on the current view and at the menu level.
                //  we need to add a language menu to switch between languages. and add it as an enum to the test schema.
                // the language should be retrieved as well from the profile of the user (as a preference).
                // the topic as part of the profile subscriptions. and the grade as part of the profile it is subscribed to.
                return <TestsPage
                    grade="6ème"
                    onStartQuiz={
                        (test) => {
                            setQuizState({test});
                            setCurrentView('quiz');
                        }
                    }
                />;
            case 'arithmetic':
                return <ArithmeticPractice numQuestions={50} onRestart={() => setCurrentView('arithmetic')}/>;
            case 'practices':
                return <TestExecutionsPage
                    onStartQuiz2={
                        (
                            test,
                            testExecution
                        ) => {
                            // const test = testExecution.test; // Assuming test is part of testExecution

                            console.log("test Execution defined at onStartQuiz2 ." + JSON.stringify(testExecution));
                            console.log("test" + JSON.stringify(test));

                            setQuizState({test, testExecution});
                            // console.log("testExecution" + JSON.stringify(testExecution));
                            setCurrentView('quiz');
                        }}
                />;
            case 'quiz':
                return <Quiz test={quizState?.test} testExecution={quizState?.testExecution}/>;
            default:
                return (
                    <div className="landing-page">

                        <h1>{I18n.get('Welcome to the Quiz App')}</h1>

                    </div>
                );
        }
    };

    return (
        <>
            <NavBarHeaderQuiz
                with={"100%"}
                overrides={{
                    "logoHeader 1": {
                        src: "logoHeader.png"
                    },
                    "Go Practice": {
                        children: I18n.get('Go Practice'),
                        onClick: () => setCurrentView('tests'),
                        onMouseOver: () => {
                            document.body.style.cursor = 'pointer';
                        },
                        onMouseOut: () => {
                            document.body.style.cursor = 'default';
                        },
                    },
                    "Results": {
                        children: I18n.get('Results'),
                        onClick: () => setCurrentView('practices'),
                        onMouseOver: () => {
                            document.body.style.cursor = 'pointer';
                        },
                        onMouseOut: () => {
                            document.body.style.cursor = 'default';
                        }
                    },
                    "Arithmetic": {children: I18n.get('Arithmetic'),
                        onClick: () => setCurrentView('arithmetic'),
                        onMouseOver: () => {
                        document.body.style.cursor = 'pointer';
                    },
                        onMouseOut: () => {
                        document.body.style.cursor = 'default';
                    }
                    },
                    "Plans": {
                        children: I18n.get('Plans'),
                        onClick: () => {
                            // signIn();
                            setCurrentView('plans');
                            // useAuthenticator();
                        },
                        onMouseOver: () => {
                            document.body.style.cursor = 'pointer';
                        },
                        onMouseOut: () => {
                            document.body.style.cursor = 'default';
                        }
                    },
                    "Button": {
                        onClick: () => {


                            signOut();
                            setCurrentView('default');
                            console.log('Sign Out');
                        }
                    }

                }}
            />
            {renderContent()}
        </>
    );
};

export default LandingPage;